import { render, staticRenderFns } from "./donate-ways.vue?vue&type=template&id=357f6831&scoped=true"
import script from "./donate-ways.vue?vue&type=script&lang=js"
export * from "./donate-ways.vue?vue&type=script&lang=js"
import style0 from "./donate-ways.vue?vue&type=style&index=0&id=357f6831&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "357f6831",
  null
  
)

export default component.exports